<template>
  <div class="page" id="guide">
    <div class="loader" v-if="isLoading">
      <van-loading size="6.4vw">加载中...</van-loading>
    </div>
    <van-empty
      :description="errorMsg || '暂无数据'"
      v-else-if="!items || JSON.stringify(items) === '{}'"
    >
      <template #image>
        <img src="../assets/empty-image-error.png" />
      </template>
    </van-empty>
    <div v-else>
      <div class="single-box" v-if="singleImage">
        <Guide-Image
          :detailImage="guideImages[0].detailImage"
          :image="guideImages[0].image"
        />
      </div>
      <div class="multi-box" v-else>
        <van-tabs class="tabs" v-model="active">
          <van-tab :key="'image@' + index" v-for="(it, index) in guideImages">
            <template #title>
              <div class="tab-title">{{ it.name }}</div>
            </template>
            <Guide-Image :detailImage="it.detailImage" :image="it.image" />
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import GuideImage from "@/components/GuideImage.vue";
import Vue from "vue";
import { Empty, Icon, Image, Loading, Tab, Tabs } from "vant";
Vue.use(Empty).use(Icon).use(Image).use(Loading).use(Tab).use(Tabs);
export default {
  name: "Guide",
  components: { GuideImage },
  data() {
    return {
      title: "银联机场贵宾权益",
      errorMsg: "",
      ds: null,
      active: 0,
      isLoading: true,
      airportId: this.$route.params.id,
    };
  },
  computed: {
    items: function () {
      return (this.ds && this.ds.data) || null;
    },
    guideImages: function () {
      let { ds, items } = this;
      if (!items) return [];
      let tmpArr = [];
      for (let i = 0; i < items.length; i++) {
        if (
          parseInt(items[i].Display) &&
          items[i].LeadPic != "" &&
          items[i].LeadDetailPic != ""
        ) {
          let t = items[i];
          let name =
            t.TerminalName && t.TerminalName != ""
              ? t.TerminalName
              : t.AirportTerminalName;
          tmpArr.push({
            name: this.formatName(name),
            image: ds.ImgServer + t.LeadPic,
            detailImage: ds.ImgServer + t.LeadDetailPic,
          });
        }
      }
      return tmpArr;
    },
    singleImage: function () {
      return this.guideImages.length == 1;
    },
  },
  created() {
    this.$parent.setNav({
      title: this.title,
    });
  },
  mounted() {
    let that = this;

    let airportId = that.$route.params.id;

    // if (that.$globalStorage.items[airportId]) {
    //   that.isLoading = false;
    //   that.ds = that.$globalStorage.items[airportId];
    //   return false;
    // }

    that.$axios
      .post("/airport/" + airportId, {
        bankType: that.$locSearch.bankType,
      })
      .then((res) => {
        console.log(res);
        if (res.data.result != 0 || !res.data.data) {
          throw res;
        } else {
          that.ds = that.$globalStorage.items[airportId] = res.data;
        }
      })
      .catch((error) => {
        let errData = error.data;
        let desp = (errData && errData.description) || "获取失败";
        that.errorMsg = desp;
        // that.$dialog({ title: desp });
      })
      .then(() => {
        that.isLoading = false;
      });
  },
  methods: {
    formatName(name) {
      if (!name || name == "") return "";
      if (name.indexOf("T") != -1 && name.indexOf("航站楼") != -1) {
        let tmp = name.match(/T(\S*)航站楼/);
        if (tmp) name = tmp[0];
      }
      return name;
    },
  },
};
</script>

<style lang="less">
@import "../main";
#guide.page {
  background: #f3f3f3;
  .loader {
    width: 100%;
    #bundle.flex-row();
    justify-content: center;
    align-items: center;
    min-height: inherit;
    box-sizing: border-box;
    padding-bottom: 5vh;
  }
  .image-box {
  }
  .multi-box {
    .tabs {
      .van-tabs__wrap {
        height: fit-content;
      }
      .van-tabs__nav {
        box-sizing: border-box;
        width: 100%;
        height: 60px;
        padding: 10px 5vw;
        background: transparent;
        .van-tabs__line {
          background: transparent;
        }
      }
      .van-tab {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        background: #252525;
        background-image: linear-gradient(#747474, #252525);
        border: 1px solid #fff;
        box-sizing: border-box;
        &.van-tab--active {
          background: #ebd291;
          background-image: linear-gradient(#d2c89b, #ebd291);
        }
        .tab-title {
        }
      }
    }
  }
}
</style>
